import { render, staticRenderFns } from "./validation-certificate.vue?vue&type=template&id=d86a20fc&"
import script from "./validation-certificate.vue?vue&type=script&lang=js&"
export * from "./validation-certificate.vue?vue&type=script&lang=js&"
import style0 from "./validation-certificate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports